module.exports = __webpack_public_path__ + "img/if_4.a13957ea.png";